import React from 'react';
import {
  TextField,
  FormField,
  formFieldRequiredLabel as requiredLabel,
  FlexColumn,
} from '@elementary/common-ui/components';
import { FormControlLabel, Checkbox, Collapse } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const DEFAULT_SSH_PORT = 22;

type Props = {
  disabled?: boolean;
};

const SshTunnelFormSection = ({ disabled }: Props) => {
  const methods = useFormContext();
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const sshEnabled = watch('sshEnabled');

  return (
    <FlexColumn gap="inherit">
      <FormControlLabel
        control={
          <Checkbox
            checked={!!sshEnabled}
            onChange={(e) => {
              setValue('sshEnabled', e.target.checked);
              const currentPort = methods.getValues('sshPort');
              if (
                e.target.checked &&
                (!Number.isInteger(currentPort) || currentPort <= 0)
              ) {
                setValue('sshPort', DEFAULT_SSH_PORT);
              }
            }}
            disabled={disabled}
          />
        }
        label="Connect via SSH tunnel"
      />
      <Collapse in={!!sshEnabled}>
        <FlexColumn sx={{ gap: '24px' }}>
          <FormField
            title="SSH Host"
            errorMessage={errors.sshHost?.message as string}
          >
            <TextField
              {...register('sshHost', {
                required: sshEnabled ? requiredLabel : false,
              })}
              variant="outlined"
              placeholder="e.g. bastion.example.com"
              disabled={disabled}
            />
          </FormField>
          <FormField
            title="SSH Port"
            errorMessage={errors.sshPort?.message as string}
          >
            <TextField
              {...register('sshPort', {
                required: sshEnabled ? requiredLabel : false,
                valueAsNumber: true,
                validate: (value) => {
                  if (!sshEnabled) {
                    return true;
                  }
                  return (
                    (Number.isInteger(value) && value >= 1 && value <= 65535) ||
                    'SSH port must be an integer between 1 and 65535'
                  );
                },
              })}
              variant="outlined"
              placeholder="22"
              type="number"
              disabled={disabled}
            />
          </FormField>
          <FormField
            title="SSH Username"
            errorMessage={errors.sshUsername?.message as string}
          >
            <TextField
              {...register('sshUsername', {
                required: sshEnabled ? requiredLabel : false,
              })}
              variant="outlined"
              placeholder="e.g. ec2-user"
              disabled={disabled}
            />
          </FormField>
        </FlexColumn>
      </Collapse>
    </FlexColumn>
  );
};

export default SshTunnelFormSection;
